export const projectTestPicture: string = 'assets/partners/project/projectTest.jpg';
